import { InputHTMLAttributes, KeyboardEventHandler } from 'react'
import { Field } from 'react-final-form'

import { Input, InputProps } from '@infura/packages.ui/Input'

type Props = InputHTMLAttributes<HTMLInputElement> &
  Partial<InputProps> & {
    validate?: (value: string | number) => void
    format?: ((value: string) => string) | ((value: number) => string)
    parse?: (value: string) => string
    isEqual?: (a: any, b: any) => boolean
    onKeyUp?: KeyboardEventHandler<HTMLInputElement>
    field?: any
  }

export default function FieldInput(props: Props) {
  // Fixes react warning for Invalid value for prop `validate` on <input> tag
  const {
    autoComplete,
    className,
    field,
    format,
    inputMode,
    isEqual,
    name,
    parse,
    pattern,
    type,
    validate,
    ...inputProps
  } = props

  return (
    <Field
      autoComplete={autoComplete}
      format={format}
      inputMode={inputMode}
      isEqual={isEqual}
      name={name}
      parse={parse}
      pattern={pattern}
      type={type}
      validate={validate}
      {...field}
    >
      {({ input, meta }) => {
        let error = undefined
        const fieldLeftBlank = meta.touched && meta.error
        const formSubmittedInvalid = meta.submitError && meta.error
        const isPasswordField = type === 'password'
        if (fieldLeftBlank || formSubmittedInvalid) error = meta.error
        if (isPasswordField && error) error = meta.error

        if (type === 'checkbox') return <input defaultValue={input.value} type={type} {...input} {...inputProps} />

        return (
          <Input
            autoComplete={autoComplete}
            className={className}
            error={error}
            // @ts-expect-error enabled to support strictNullChecks - Please fix this if you can!
            type={type}
            {...input}
            {...inputProps}
          />
        )
      }}
    </Field>
  )
}
